import { useState } from "react";
import { Info } from "lucide-react";
import { TutorialModal } from "./TutorialModal";

export function InfoButton({ topic, className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        data-testid={`info-button-${topic}`}
        onClick={() => setOpen(true)}
        title="How does this work?"
        className={`w-6 h-6 rounded-full flex items-center justify-center border border-[#D4AF37]/40 text-[#D4AF37] hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] transition-colors duration-200 shrink-0 ${className}`}
      >
        <Info className="w-3.5 h-3.5" />
      </button>
      <TutorialModal topic={topic} open={open} onOpenChange={setOpen} />
    </>
  );
}
